import { render } from "./ChangedOrientationInformer.vue?vue&type=template&id=66a501e3&scoped=true"
import script from "./ChangedOrientationInformer.vue?vue&type=script&lang=js"
export * from "./ChangedOrientationInformer.vue?vue&type=script&lang=js"

import "./ChangedOrientationInformer.vue?vue&type=style&index=0&id=66a501e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a501e3"]])

export default __exports__